import { NotifyHelper } from "../../../helpers/toast";
import { objHocSinhAceDefine } from "../../action-types/hoc-sinh/IHocSinhAceActionTypes";
import { generateActionForKey, generateActions } from "../generateActions";



export const hocSinhAceActions = {
    ...generateActions(objHocSinhAceDefine, "HOC_SINH_ACE"),
    ...generateActionForKey(objHocSinhAceDefine, "HOC_SINH_ACE",
        "LOAD_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objHocSinhAceDefine, "HOC_SINH_ACE",
        "SAVE_SUCESS", (m: any) => NotifyHelper.Success("Saved")),
    ...generateActionForKey(objHocSinhAceDefine, "HOC_SINH_ACE",
        "SAVE_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objHocSinhAceDefine, "HOC_SINH_ACE",
        "DELETE_SUCESS", (m: any) => NotifyHelper.Success("Deleted")),
    ...generateActionForKey(objHocSinhAceDefine, "HOC_SINH_ACE",
        "DELETE_ERROR", (m: any) => NotifyHelper.Error(m))
}
